import module from './core.questionnaire.module'

export default module.name
